// actions.ts
import { createAction, props } from '@ngrx/store';
import { CustomComponent } from '../../models/CustomComponent.model';
import { CustomTemplate } from '../../models/CustomTemplate.model';
import { CustomSlug } from '../../models/CustomSlug.model';

//export const addComponent = createAction('[Template] Add Component', props<{ component: CustomComponent }>());
//export const updateComponentCoordinates = createAction('[Template] Update Component Coordinates', props<{ id: string, coordinates: { x: number, y: number } }>());
//export const removeComponent = createAction('[Template] Remove Component', props<{ id: string }>());
//export const loadComponents = createAction('[Template] Load Components');
//export const loadComponentsSuccess = createAction('[Template] Load Components Success', props<{ components: CustomComponent[] }>());
//export const loadComponentsFailure = createAction('[Template] Load Components Failure', props<{ error: any }>());

export const loadPageDataBySlug = createAction(
  '[Template] Load Page Data By Slug',
  props<{ slug: string }>()
);

export const loadPageDataSuccess = createAction(
  '[Template] Load Page Data Success',
  props<{ 
    slug: string; 
    templatesChanged: boolean;
    hasCustomSlug: boolean;
    hasTemplates: boolean;
    data?: any;
  }>()
);

export const loadPageDataFailure = createAction('[Template] Load Page Data Failure', props<{ error: any }>());

export const navigateTo404 = createAction('[Template] Navigate to 404');

export const loadStaticTemplateSuccess = createAction(
  '[Template] Load Static Template Success',
  props<{ slug: string; staticTemplate: CustomTemplate }>()
);

export const loadDynamicTemplateSuccess = createAction(
  '[Template] Load Dynamic Template Success',
  props<{ slug: string; dynamicTemplate: CustomTemplate }>()
);

export const loadCustomSlugSuccess = createAction(
  '[Template] Load Custom Slug Success',
  props<{ slug: string; customSlug: CustomSlug }>()
);

export const loadPageDataUnchanged = createAction(
  '[Template] Load Page Data Unchanged',
  props<{ slug: string }>()
);

export const lazyLoadPageData = createAction(
  '[Template] Lazy Load Page Data',
  props<{ 
    slug: string; 
    staticTemplate: CustomTemplate | null; 
    dynamicTemplate: CustomTemplate | null; 
    customSlug: CustomSlug | null;
    data?: any;
  }>()
);

export const setCurrentMode = createAction(
  '[Template] Set Current Mode',
  props<{ mode: 1 | 2 | 3 }>()
);
